import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { api } from '../../Api-Endpoints/apiEndpoint';
import ApiHandler from '../../ApiHandler';

const RenameFolderModal = ({ showModal, setShowModal, folder }) => {
  const [folderName, setFolderName] = useState(folder?.name || '');

  // Update folderName when folder changes
  useEffect(() => {
    setFolderName(folder?.name || '');
  }, [folder]);

  const closeModal = () => {
    setShowModal(false);
  };

  const updateFolders = async () => {
    try {
      const { status, data } = await api.patch(
        `/folder/editfolder/${folder?._id}`,
        {
          name: folderName,
        }
      );
      ApiHandler.getFolders();
      closeModal();
    } catch (error) {
      console.error('Error updating folder:', error);
      // Optional: Show error feedback to the user
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel="Rename Folder"
      style={{
        content: {
          width: '50%',
          height: '50%',
          margin: 'auto',
          borderRadius: '20px',
          padding: 0,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <div className="flex justify-between mx-5 my-3">
        <h3 className="font-medium">Rename Folder</h3>
        <button onClick={closeModal}>
          <IoMdCloseCircleOutline size={20} />
        </button>
      </div>
      <hr />
      <div className="flex justify-center mx-5 my-3">
        <h2>Enter new name to update folder</h2>
      </div>
      <div className="flex justify-center mx-5 my-3">
        <input
          className="p-2 w-50 bg-purple-100 border rounded-lg text-sm outline-none my-1"
          type="text"
          id="search"
          onChange={e => setFolderName(e.target.value)}
          value={folderName}
          placeholder="Enter Name"
        />
      </div>
      <div className="flex justify-end mx-5 my-3 gap-3">
        <button
          onClick={closeModal}
          className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
        >
          Cancel
        </button>
        <button
          onClick={updateFolders}
          className="border border-red-500 bg-red-700 text-white p-1 px-5 rounded-lg"
        >
          Update
        </button>
      </div>
    </Modal>
  );
};

export default RenameFolderModal;
